import React from "react";
import cx from "classnames";
import styles from "../../scss/AFDialog.module.scss";
import LModal from "../../../common/components/Modals/LModal/LModal";
import Button from "../../../common/components/Forms/Button/Button";

interface IAFSkipQuestionDialog {
    isOpen: boolean;
    handleSkip: () => void;
    onClose: () => void;
}

const AFSkipQuestionDialog: React.FC<IAFSkipQuestionDialog> = (props) => {
    const { isOpen, handleSkip, onClose } = props;

    return (
        <LModal
            Header={() => null}
            calcHeightMode="auto"
            width="normal"
            removePadding={true}
            isOpen={isOpen}
            onClose={onClose}>
            {() => {
                return (
                    <div className={cx(styles["af-warning-dialog-modal"])}>
                        <div className={styles["af-warning__header"]}>
                            <h2>Skip question</h2>
                        </div>
                        <div className={cx(styles["af-warning__content"], "layout-flex-column")}>
                            <p className={styles["af-warning__desc"]}>
                                Don't know an exact answer? No sweat, our friendly team are here to help. However the more you tell us the easier the application process should be.
                            </p>
                            <Button
                                className={cx(styles["af-warning__continue"], )}
                                width="fill"
                                component="button"
                                size="s"
                                onClick={handleSkip}
                                variant="calltoaction">
                                <span>Okay</span>
                            </Button>
                            <button
                                type="button"
                                className={cx("text-back-link", "button-link", "width-full")}
                                onClick={onClose}>
                                Cancel
                            </button>
                        </div>
                    </div>
                );
            }}
        </LModal>
    );
};

export default AFSkipQuestionDialog;
